import { ValidationStrategy } from "./validation.strategy";

export class TextValidationStrategy extends ValidationStrategy {

    public validate(): boolean {
        let isValid = true;

        if (this.isRequired && 
            !this.isDisabled && 
            !this.isHidden &&
            !this.attribute.value) {
            isValid = false;
        }

        if(isValid) {
            const minValueOpt = this.attribute.options
                .find(opt => opt.key.toLowerCase() == "minvalue");

            if(minValueOpt) {
                isValid = +this.attribute.value >= +minValueOpt.value;
            }
        }

        if(isValid) {
            const maxValueOpt = this.attribute.options
                .find(opt => opt.key.toLowerCase() == "maxvalue");

            if(maxValueOpt) {
                isValid = +this.attribute.value <= +maxValueOpt.value;
            }
        }

        if(isValid) {
            const minLengthOpt = this.attribute.options
                .find(opt => opt.key.toLowerCase() == "minlength");

            if(minLengthOpt && this.attribute.value) {
                isValid = this.attribute.value.length >= +minLengthOpt.value;
            }
        }

        if(isValid) {
            const maxLengthOpt = this.attribute.options
                .find(opt => opt.key.toLowerCase() == "maxlength");

            if(maxLengthOpt && this.attribute.value) {
                isValid = this.attribute.value.length <= +maxLengthOpt.value;
            }
        }

        if(isValid) {
            let completeName = this.attribute.options
                .find(option => option.key.toLowerCase() == 'completename');
        
            if(completeName){
                isValid = (this.validateCompleteName());
            }
        }

        this.attribute.hasError = !isValid

        return isValid;
    }
}